// @ts-nocheck
/* tslint:disable */
/* auto-generated angular directive proxies */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';

import { ProxyCmp, proxyOutputs } from './angular-component-lib/utils';

import type { Components } from 'europace-components/components';

import { defineCustomElement as defineCheckboxComponent } from 'europace-components/components/checkbox-component.js';
import { defineCustomElement as defineCustomerOverviewComponent } from 'europace-components/components/customer-overview-component.js';
import { defineCustomElement as defineDragAndDropComponent } from 'europace-components/components/drag-and-drop-component.js';
import { defineCustomElement as defineDynamicOrderProgressionStepper } from 'europace-components/components/dynamic-order-progression-stepper.js';
import { defineCustomElement as defineDynamicStepperComponent } from 'europace-components/components/dynamic-stepper-component.js';
import { defineCustomElement as defineFooterComponent } from 'europace-components/components/footer-component.js';
import { defineCustomElement as defineHeaderComponent } from 'europace-components/components/header-component.js';
import { defineCustomElement as defineInfoComponent } from 'europace-components/components/info-component.js';
import { defineCustomElement as defineInputFieldComponent } from 'europace-components/components/input-field-component.js';
import { defineCustomElement as defineLoadingSpinner } from 'europace-components/components/loading-spinner.js';
import { defineCustomElement as defineMyComponent } from 'europace-components/components/my-component.js';
import { defineCustomElement as defineOrderOverviewComponent } from 'europace-components/components/order-overview-component.js';
import { defineCustomElement as defineOrderProgressionStep } from 'europace-components/components/order-progression-step.js';
import { defineCustomElement as defineOverviewComponent } from 'europace-components/components/overview-component.js';
import { defineCustomElement as defineRadioButtonComponent } from 'europace-components/components/radio-button-component.js';
import { defineCustomElement as defineShoppingCartView } from 'europace-components/components/shopping-cart-view.js';
import { defineCustomElement as defineSimpleAccordion } from 'europace-components/components/simple-accordion.js';
import { defineCustomElement as defineStepComponent } from 'europace-components/components/step-component.js';
import { defineCustomElement as defineTextComponent } from 'europace-components/components/text-component.js';
import { defineCustomElement as defineThemeButton } from 'europace-components/components/theme-button.js';
@ProxyCmp({
  defineCustomElementFn: defineCheckboxComponent,
  inputs: ['checkboxErrorMessage', 'checkboxHelperText', 'checkboxLabel', 'checkboxPrice', 'checked', 'isDisabled', 'isError', 'isSmallButton', 'label', 'value']
})
@Component({
  selector: 'checkbox-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['checkboxErrorMessage', 'checkboxHelperText', 'checkboxLabel', 'checkboxPrice', 'checked', 'isDisabled', 'isError', 'isSmallButton', 'label', 'value'],
  standalone: true
})
export class CheckboxComponent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['valueChanged']);
  }
}


export declare interface CheckboxComponent extends Components.CheckboxComponent {

  valueChanged: EventEmitter<CustomEvent<string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCustomerOverviewComponent,
  inputs: ['customerInfo']
})
@Component({
  selector: 'customer-overview-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['customerInfo'],
  standalone: true
})
export class CustomerOverviewComponent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CustomerOverviewComponent extends Components.CustomerOverviewComponent {}


@ProxyCmp({
  defineCustomElementFn: defineDragAndDropComponent,
  inputs: ['buttontext', 'errorMessage', 'files', 'instruction', 'isError', 'isLoading']
})
@Component({
  selector: 'drag-and-drop-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['buttontext', 'errorMessage', 'files', 'instruction', 'isError', 'isLoading'],
  standalone: true
})
export class DragAndDropComponent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['fileChanged']);
  }
}


export declare interface DragAndDropComponent extends Components.DragAndDropComponent {

  fileChanged: EventEmitter<CustomEvent<File | undefined>>;
}


@ProxyCmp({
  defineCustomElementFn: defineDynamicOrderProgressionStepper,
  inputs: ['label', 'progressInfos']
})
@Component({
  selector: 'dynamic-order-progression-stepper',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['label', 'progressInfos'],
  standalone: true
})
export class DynamicOrderProgressionStepper {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['downloadClicked']);
  }
}


export declare interface DynamicOrderProgressionStepper extends Components.DynamicOrderProgressionStepper {

  downloadClicked: EventEmitter<CustomEvent<void>>;
}


@ProxyCmp({
  defineCustomElementFn: defineDynamicStepperComponent,
  inputs: ['currentStep', 'isVertical', 'steps']
})
@Component({
  selector: 'dynamic-stepper-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['currentStep', 'isVertical', 'steps'],
  standalone: true
})
export class DynamicStepperComponent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface DynamicStepperComponent extends Components.DynamicStepperComponent {}


@ProxyCmp({
  defineCustomElementFn: defineFooterComponent,
  inputs: ['epIconSrcPath', 'impressUrl', 'valIconSrcPath']
})
@Component({
  selector: 'footer-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['epIconSrcPath', 'impressUrl', 'valIconSrcPath'],
  standalone: true
})
export class FooterComponent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['linkClicked']);
  }
}


export declare interface FooterComponent extends Components.FooterComponent {

  linkClicked: EventEmitter<CustomEvent<string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineHeaderComponent,
  inputs: ['brandSrcPath', 'counter', 'productData']
})
@Component({
  selector: 'header-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['brandSrcPath', 'counter', 'productData'],
  standalone: true
})
export class HeaderComponent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['linkClicked']);
  }
}


export declare interface HeaderComponent extends Components.HeaderComponent {

  linkClicked: EventEmitter<CustomEvent<any>>;
}


@ProxyCmp({
  defineCustomElementFn: defineInfoComponent,
  inputs: ['buttonLabel', 'emphasis', 'infoHeadline', 'infoText', 'showButton', 'showCloseIcon', 'showInfoHeadline', 'type']
})
@Component({
  selector: 'info-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['buttonLabel', 'emphasis', 'infoHeadline', 'infoText', 'showButton', 'showCloseIcon', 'showInfoHeadline', 'type'],
  standalone: true
})
export class InfoComponent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface InfoComponent extends Components.InfoComponent {}


@ProxyCmp({
  defineCustomElementFn: defineInputFieldComponent,
  inputs: ['anyIcon', 'autocomplete', 'errorMessage', 'helperText', 'isDisabled', 'isError', 'label', 'labelId', 'linkText', 'linkUrl', 'name', 'placeHolder', 'value']
})
@Component({
  selector: 'input-field-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['anyIcon', 'autocomplete', 'errorMessage', 'helperText', 'isDisabled', 'isError', 'label', 'labelId', 'linkText', 'linkUrl', 'name', 'placeHolder', 'value'],
  standalone: true
})
export class InputFieldComponent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['valueChanged', 'linkClicked', 'blurred']);
  }
}


export declare interface InputFieldComponent extends Components.InputFieldComponent {

  valueChanged: EventEmitter<CustomEvent<string>>;

  linkClicked: EventEmitter<CustomEvent<string>>;

  blurred: EventEmitter<CustomEvent<void>>;
}


@ProxyCmp({
  defineCustomElementFn: defineLoadingSpinner
})
@Component({
  selector: 'loading-spinner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
  standalone: true
})
export class LoadingSpinner {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface LoadingSpinner extends Components.LoadingSpinner {}


@ProxyCmp({
  defineCustomElementFn: defineMyComponent,
  inputs: ['first', 'last', 'middle']
})
@Component({
  selector: 'my-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['first', 'last', 'middle'],
  standalone: true
})
export class MyComponent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface MyComponent extends Components.MyComponent {}


@ProxyCmp({
  defineCustomElementFn: defineOrderOverviewComponent,
  inputs: ['productData', 'sum', 'sumText', 'taxRate', 'taxText']
})
@Component({
  selector: 'order-overview-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['productData', 'sum', 'sumText', 'taxRate', 'taxText'],
  standalone: true
})
export class OrderOverviewComponent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface OrderOverviewComponent extends Components.OrderOverviewComponent {}


@ProxyCmp({
  defineCustomElementFn: defineOrderProgressionStep,
  inputs: ['isLast', 'progressInfo']
})
@Component({
  selector: 'order-progression-step',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['isLast', 'progressInfo'],
  standalone: true
})
export class OrderProgressionStep {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['downloadClicked']);
  }
}


export declare interface OrderProgressionStep extends Components.OrderProgressionStep {

  downloadClicked: EventEmitter<CustomEvent<void>>;
}


@ProxyCmp({
  defineCustomElementFn: defineOverviewComponent,
  inputs: ['customerInfo', 'productData']
})
@Component({
  selector: 'overview-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['customerInfo', 'productData'],
  standalone: true
})
export class OverviewComponent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface OverviewComponent extends Components.OverviewComponent {}


@ProxyCmp({
  defineCustomElementFn: defineRadioButtonComponent,
  inputs: ['checked', 'isDisabled', 'isError', 'isSmallButton', 'label', 'radioButtonErrorMessage', 'radioButtonHelperText', 'radioButtonLabel', 'radioButtonPrice', 'value']
})
@Component({
  selector: 'radio-button-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['checked', 'isDisabled', 'isError', 'isSmallButton', 'label', 'radioButtonErrorMessage', 'radioButtonHelperText', 'radioButtonLabel', 'radioButtonPrice', 'value'],
  standalone: true
})
export class RadioButtonComponent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['valueChanged']);
  }
}


export declare interface RadioButtonComponent extends Components.RadioButtonComponent {

  valueChanged: EventEmitter<CustomEvent<string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineShoppingCartView,
  inputs: ['productData', 'showButton']
})
@Component({
  selector: 'shopping-cart-view',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['productData', 'showButton'],
  standalone: true
})
export class ShoppingCartView {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface ShoppingCartView extends Components.ShoppingCartView {}


@ProxyCmp({
  defineCustomElementFn: defineSimpleAccordion,
  inputs: ['isOpen', 'label']
})
@Component({
  selector: 'simple-accordion',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['isOpen', 'label'],
  standalone: true
})
export class SimpleAccordion {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['accordionToggle']);
  }
}


export declare interface SimpleAccordion extends Components.SimpleAccordion {

  accordionToggle: EventEmitter<CustomEvent<any>>;
}


@ProxyCmp({
  defineCustomElementFn: defineStepComponent,
  inputs: ['currentStep', 'description', 'isVertical', 'numOfSteps', 'stepNum']
})
@Component({
  selector: 'step-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['currentStep', 'description', 'isVertical', 'numOfSteps', 'stepNum'],
  standalone: true
})
export class StepComponent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface StepComponent extends Components.StepComponent {}


@ProxyCmp({
  defineCustomElementFn: defineTextComponent,
  inputs: ['variation']
})
@Component({
  selector: 'text-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['variation'],
  standalone: true
})
export class TextComponent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface TextComponent extends Components.TextComponent {}


@ProxyCmp({
  defineCustomElementFn: defineThemeButton,
  inputs: ['disabled', 'isError', 'isLoading', 'variation']
})
@Component({
  selector: 'theme-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled', 'isError', 'isLoading', 'variation'],
  standalone: true
})
export class ThemeButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['press']);
  }
}


export declare interface ThemeButton extends Components.ThemeButton {

  press: EventEmitter<CustomEvent<void>>;
}


